import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import VideocamIcon from "@mui/icons-material/Videocam";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import DescriptionIcon from "@mui/icons-material/Description";

import useResolvers from "src/hooks/useResolvers";

const Playlist = ({ lectures, selected, setSelected }) => {
  const { t } = useTranslation();

  return (
    <Box className="lecture-playlist">
      {lectures?.length ? (
        lectures?.map((item, idx) => (
          <ListItem
            key={idx}
            lecture={item}
            selected={selected}
            setSelected={setSelected}
          />
        ))
      ) : (
        <Box my={2} className="align-center">
          <Typography variant="caption">
            {t("questions.bulkQuestionGeneration.steps.step1.emptyLectures")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

const ListItem = ({ lecture, selected, setSelected }) => {
  const { t } = useTranslation();
  const status = selected?.id === lecture?.id ? "watching" : "unwatched";
  const { LectureTypes } = useResolvers();

  const formatTime = (seconds) => {
    if (!seconds) return "00 Mins";

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(remainingSeconds?.toFixed(0)).padStart(
      2,
      "0"
    );

    if (formattedHours === "00") {
      return `${formattedMinutes} Mins ${formattedSeconds} Secs`;
    }
    return `${formattedHours} Hours ${formattedMinutes} Mins ${formattedSeconds} Secs`;
  };

  const lectureTypeIndentifierIcon = () => {
    const styles = { color: "#B9BCC1", fontSize: "1rem" };
    switch (lecture?.type) {
      case 1:
        return <VideocamIcon sx={styles} />;
      case 2:
        return <AudiotrackIcon sx={styles} />;
      case 3:
        return <DescriptionIcon sx={styles} />;
      default:
        return null;
    }
  };

  return (
    <Box
      onClick={() => setSelected(lecture)}
      className={"list-item space-between d-flex " + status}
    >
      <Box className={"icon-box " + status}>{lectureTypeIndentifierIcon()}</Box>
      <Box className="desc-box">
        <Typography variant="h2">{lecture?.name}</Typography>
        {LectureTypes[t("lectureTypes.theory")] === lecture?.type ? null : (
          <Typography variant="h3">
            {formatTime(lecture?.duration) || "0 Mins"}
          </Typography>
        )}
        <Typography variant="h3">
          {lecture?.tags?.map((t) => t.name)?.join(",") || ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default Playlist;
